import { fetchStreamUrl } from './audioApi';

interface CacheEntry {
  url: string;
  expiresAt: number; // epoch ms
}

const cache = new Map<number, CacheEntry>();
const FIVE_MIN = 5 * 60 * 1000;

// Returns a valid signed stream URL for a documentId, refreshing when it has
// fewer than 5 minutes left (or on forceRefresh).
export async function getOrRefreshUrl(documentId: number, forceRefresh = false): Promise<string> {
  const existing = cache.get(documentId);
  if (!forceRefresh && existing && existing.expiresAt - Date.now() > FIVE_MIN) {
    return existing.url;
  }
  const { url, expiresAt } = await fetchStreamUrl(documentId);
  cache.set(documentId, { url, expiresAt: expiresAt ?? Date.now() + 55 * 60 * 1000 });
  return url;
}

export function clearCachedUrl(documentId: number): void {
  cache.delete(documentId);
}
